import { fetchApi, fetchPostApi } from "../../../helpers/fetch";

// Fetch admin dashboard statistics
export const fetchAdminStats = async () => {
    try {
        const response = await fetchApi('/admin/stats');
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch growth statistics (week-over-week or month-over-month)
export const fetchGrowthStats = async (period = 'week') => {
    try {
        const response = await fetchApi(`/admin/stats/growth?period=${period}`);
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Bulk-create creator/customer accounts. Synchronous: the backend processes the
 * whole batch and returns { success, summary, results } in a single response.
 * @param {{ csv?: string, entries?: object[] }} body
 */
export const startBulkSignup = (body) => fetchPostApi("/admin/invitations/bulk", body);

// Removed redundant separate endpoints - using single /admin/stats endpoint instead
// for better performance and consistency

/*
// Fetch total users count
export const fetchTotalUsers = async () => {
    try {
        const response = await fetchApi('/admin/users/count');
        return response;
    } catch (error) {
        console.error('Error fetching total users:', error);
        throw error;
    }
};

// Fetch total creators count
export const fetchTotalCreators = async () => {
    try {
        const response = await fetchApi('/admin/users/creators/count');
        return response;
    } catch (error) {
        console.error('Error fetching total creators:', error);
        throw error;
    }
};

// Fetch total creations count
export const fetchTotalCreations = async () => {
    try {
        const response = await fetchApi('/admin/creations/count');
        return response;
    } catch (error) {
        console.error('Error fetching total creations:', error);
        throw error;
    }
};

// Fetch total revenue
export const fetchTotalRevenue = async () => {
    try {
        const response = await fetchApi('/admin/payments/revenue');
        return response;
    } catch (error) {
        console.error('Error fetching total revenue:', error);
        throw error;
    }
};
*/ 